import { useState } from "react";
import { ArrowRight } from "lucide-react";
import InteriorsQuoteModal from "@/pages/interiors/InteriorsQuoteModal";

export default function InteriorsHero() {
  const [showModal, setShowModal] = useState(false);

  return (
    <section id="ts-interiors-hero" style={{
      position: "relative",
      paddingTop: "clamp(140px, 16vw, 180px)",
      paddingBottom: "clamp(48px, 6vw, 80px)",
      paddingLeft: "clamp(20px, 5vw, 80px)",
      paddingRight: "clamp(20px, 5vw, 80px)",
      backgroundColor: "#f4f2f0",
      overflow: "hidden",
    }}>
      <div style={{ maxWidth: 1200, margin: "0 auto", position: "relative", zIndex: 2, textAlign: "center" }}>
        <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase", color: "#888", marginBottom: 16, marginTop: 0 }}>
          Interiors &amp; Staging
        </p>
        <h1 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: "clamp(36px, 5.5vw, 64px)", lineHeight: 1.05, letterSpacing: "-0.03em", color: "#1A1A1A", margin: "0 auto 20px", maxWidth: 820 }}>
          From empty shell to<br />
          <span style={{ color: "#1A1A1A" }}>fully styled Airbnb.</span>
        </h1>
        <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "clamp(16px, 2vw, 19px)", fontWeight: 400, color: "#555", lineHeight: 1.65, maxWidth: 560, margin: "0 auto 40px" }}>
          The fastest way from an empty shell to a live Airbnb. Furnishing in 7 days, fully managed and live on the platforms within 2 weeks.
        </p>

        <div style={{ display: "flex", justifyContent: "center", gap: 12, flexWrap: "wrap" }} className="interiors-hero-btns">
          <button
            onClick={() => setShowModal(true)}
            style={{ background: "hsl(var(--primary))", color: "#fff", border: "none", borderRadius: 10, padding: "15px 28px", fontFamily: "'DM Sans', sans-serif", fontSize: 15, fontWeight: 600, cursor: "pointer", display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8, transition: "background 0.2s" }}
            onMouseEnter={e => e.currentTarget.style.background = "#C4C024"}
            onMouseLeave={e => e.currentTarget.style.background = "hsl(var(--primary))"}
          >
            Request a quote <ArrowRight size={16} />
          </button>
          <a
            href="#packages"
            style={{ background: "transparent", border: "1.5px solid #D5D2CE", color: "#1A1A1A", borderRadius: 10, padding: "14px 26px", fontFamily: "'DM Sans', sans-serif", fontSize: 15, fontWeight: 500, textDecoration: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", transition: "border-color 0.2s" }}
            onMouseEnter={e => e.currentTarget.style.borderColor = "#1A1A1A"}
            onMouseLeave={e => e.currentTarget.style.borderColor = "#D5D2CE"}
          >
            View packages
          </a>
        </div>
      </div>

      {/* Hero image strip */}
      <div style={{ maxWidth: 1200, margin: "40px auto 0", position: "relative", zIndex: 2 }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 14 }} className="interiors-hero-grid">
          <div style={{ borderRadius: 14, overflow: "hidden", height: 220 }}>
            <img src="https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/bc8ff6754_generated_image.png" alt="Styled lounge" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
          </div>
          <div className="interiors-hero-img-2" style={{ borderRadius: 14, overflow: "hidden", height: 220 }}>
            <img src="https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/1390efad4_generated_image.png" alt="Equipped kitchen" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
          </div>
          <div className="interiors-hero-img-3" style={{ borderRadius: 14, overflow: "hidden", height: 220 }}>
            <img src="https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/7eea03570_generated_image.png" alt="Staged bedroom" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
          </div>
        </div>
      </div>

      {showModal && <InteriorsQuoteModal onClose={() => setShowModal(false)} onSubmitted={() => setShowModal(false)} />}

      <style>{`
        @media (max-width: 768px) {
          .interiors-hero-btns { flex-direction: column !important; align-items: stretch !important; width: 100%; max-width: 400px; margin: 0 auto; }
          .interiors-hero-btns button, .interiors-hero-btns a { width: 100% !important; box-sizing: border-box !important; }
          .interiors-hero-img-2, .interiors-hero-img-3 { display: none !important; }
          .interiors-hero-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}